import { render, staticRenderFns } from "./ProductColors.vue?vue&type=template&id=e200efac"
import script from "./ProductColors.vue?vue&type=script&lang=js"
export * from "./ProductColors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports